export enum PackingCategoryEnum {
    POUCH = 'Pouch',
    RING = 'Ring',
    CARTON = 'Carton',
    SKEWER =  'Skewer',
    PLATTER =  'Platter',
    TRIM =  'Trim',
}
